import {useState, useEffect} from 'react'
import {BrowserRouter as Router, Route} from 'react-router-dom'
import { createClient } from '@supabase/supabase-js'

import Header from './components/header'
import Tasks from './components/tasks'
import AddTask from './components/AddTask'
import Footer from './components/Footer'
import About from './components/About'


const SUPABASE_URL = "https://knrndkfimfgbsajgtokp.supabase.co"
const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlhdCI6MTYyNTAzNzAxNywiZXhwIjoxOTQwNjEzMDE3fQ.ZwpnwoZl55NVvhxaQABkmRVUMBto-ldfR0OHPkEBHew'
const supabase = createClient(SUPABASE_URL, SUPABASE_KEY)


//const taskListRef = db.ref("taskList")
// const newTask = taskListRef.push()
// newTask.set({
//   "text": "Hi Guys2",
//   "day": "Tomorrow2",
//   "reminder": false,
//   "id": 1
// })



function App() {
  //[array, state name]= (default)
  const [showAddTask, setShowAddTask] = useState(false)

  //state object that holds all tasks
  const [taskList, setTasks] = useState([])

  //initial loading of items
  useEffect (()=> {
    const getTasks = async () => {
      const tasksFromServer = await fetchTasks()
      setTasks(tasksFromServer)
    }
   
    getTasks()
  }, [])


  //fetch tasks
  const fetchTasks = async () => {
    //const res = await fetch('http://localhost:5000/taskList')
    //const data = await res.json()
    //return data
    try {
      let { data, error, status } = await supabase
        .from('taskList')
        .select(`*`)

      if (error && status !== 406) {
        throw error
      }

      if (data) {
        console.log(data);
        return data
      }
    } catch (error) {
      alert(error.message)
    } finally {

    }
  }

  const fetchTask = async (id) => {
    // const res = await fetch('http://localhost:5000/taskList/'+id)
    // const data = await res.json()
    // return data

    try {
      let { data, error, status } = await supabase
        .from('taskList')
        .select('*')
        .eq('id', id)

      if (error && status !== 406) {
        throw error
      }

      if (data) {
        //console.log(data);
        return data
      }
    } catch (error) {
      alert(error.message)
    } finally {

    }


  }

//=============================================================//


  //add task
  const addTaskToList = async (task) => {
    // const res = await fetch('http://localhost:5000/taskList/',
    // {
    //   method: 'POST',
    //   headers: {
    //     'Content-type': 'application/json' 
    //   },
    //   body: JSON.stringify(task)
    // })

    // const data = await res.json()
    try {
      const { data, error } = await supabase
      .from('taskList')
      .insert([task])

      if (error) {
        throw error
      }

      if (data) {
        //console.log(data);
        setTasks([...taskList, data[0]])
        return data
      }
    } catch (error) {
      alert(error.message)
    } finally {

    }


    // setTasks([...taskList, data])

    }

  //delete task
  const deleteTask = async (id) => {
  //uses the state defined and applies a filter
  //.filter creates a new array with all elements passed and a function acting on data
  //sets the taskList to new array

    // await fetch('http://localhost:5000/taskList/' + id,
    // {
    //   method: 'DELETE',
    // })

    try {
      const { data, error } = await supabase
      .from('taskList')
      .delete()
      .match({ id: id })

      if (error) {
        throw error
      }

      if (data) {
        //console.log(data);
        setTasks(taskList.filter((task) => task.id !== id))
        return data
      }
    } catch (error) {
      alert(error.message)
    } finally {

    }
    
    //setTasks(taskList.filter((task) => task.id !== id))

  }

  //toggle reminder
  const toggleReminder = async (id) => {
    //gets state
    // ...task (gets spread, same as  a={this.props.a} b={this.props.b})
    // console.log(fetchTask(id))
    const taskToTogggle = await fetchTask(id)
    //const updTask = {...taskToTogggle, reminder: !taskToTogggle.reminder }
    console.log(taskToTogggle[0])
    //const currentTaskReminder = await taskToTogggle[0].reminder
    let setReminder = 'true'
    if(taskToTogggle[0].reminder === true)
    {
      setReminder = 'false'
      //alert('false') 
    }
    if(taskToTogggle[0].reminder === false)
    {
      setReminder = 'true'
      //alert('true') 
    }
    
      
    // )
    // const res = await fetch('http://localhost:5000/taskList/'+id,
    // {
    //   method: 'PUT',
    //   headers: {
    //     'Content-type': 'application/json' 
    //   },
    //   body: JSON.stringify(updTask)
    // })

    //const data = await res.json()

    try {
      let { data, error} = await supabase
        .from('taskList')
        .update({ reminder: setReminder })
        .eq('id', id)

      if (error) {
        throw error
      }

      if (data) {
        //console.log(data);
        setTasks(taskList.map((task) => task.id === id ? {...task, reminder: data[0].reminder } : task))
        return data
      }
    } catch (error) {
      console.log(error.message)
    } finally {

    }
    
    //const item = await data.json()


    //setTasks(taskList.map((task) => task.id === id ? {...task, reminder: data.reminder } : task))
 
  }



//====================================================================//



  return (
    <Router>
      <div className="container">
        {/* sets the opposite of  "showAddTask" and pushes it into the header*/}
        <Route exact path='/' render={()=> (
          <>
          <Header onAdd={()=>setShowAddTask(!showAddTask)} showAdd={showAddTask}/>
          {showAddTask ? <AddTask onAdd={addTaskToList}/> :''}
        
        {taskList.length > 0 ? <Tasks taskList = {taskList} onDelete={deleteTask} onToggle={toggleReminder} />
        : 'No Tasks'}
        <Footer />
          </>
          
        )}>
        </Route>
        <Route path='/about' component={About}></Route>
      </div>
    </Router>


  );
  //<Router>
  // <Route exact path='/about' render={()=> (
  //   <>

  //   </>
  // )}></Route>
  // <Route path='/about' component={About}></Route>
  //</Router>

  // <img src={} />


}

export default App;
